let serviceClient;

const set = (client) => {
  serviceClient = client;
};

const get = () => serviceClient;

export default { set, get };
